import { jwtDecode } from "jwt-decode";
import moment from "moment";

const checkForExpiredToken = () => {
    const token = localStorage.getItem("user")
    const decoded = jwtDecode(token ?? "");

    let isTokenExpired = false;

    if (decoded.exp) {
        const tokenTime = moment.unix(decoded.exp)

        const currentTime = moment()

        const tokenExpired = currentTime.isAfter(tokenTime.subtract(1, "minute"))

        isTokenExpired = tokenExpired
    } else {
        isTokenExpired = false
    }

    return isTokenExpired
}

export default checkForExpiredToken